/**
 * Builds deep link URLs for DefectDojo resources.
 */
export function buildFindingUrl(baseUrl: string, findingId: number): string {
  return `${baseUrl}/finding/${findingId}`;
}

export function buildProductUrl(baseUrl: string, productId: number): string {
  return `${baseUrl}/product/${productId}`;
}

export function buildEngagementUrl(baseUrl: string, engagementId: number): string {
  return `${baseUrl}/engagement/${engagementId}`;
}
